import React from "react";
import * as yup from "yup";
import Input from "../../Input/Input";
import Dropdown from "../../Dropdown/Dropdown";
import DatePicker from "../../DatePicker/DatePicker";
import Checkbox from "../../Checkbox/Checkbox";
import { ATTRIBUTE_TYPES } from "../../../../constants";
import trashIcon from "../../../assets/images/trashDarkenedGreenIcon.svg";

const numberOrDecimalRegex = /^[0-9][.\d]*(,\d+)?$/;

const SelectedAttributes = ({
  selectedElements,
  handleChange,
  handleRemoveElement,
}) => (
  <>
    {!!selectedElements.length && (
      <div className="flex flex-col gap-6 overflow-scroll h-full">
        {selectedElements.map(
          ({ id, detail, fieldType, unit, data, options, isNew }) => {
            const { value, unitId, optionId } = data;
            let resultElmt;

            const unitOptions = isNew
              ? unit?.options
              : unit?.options?.map(({ id: unitDDLId, name }) => ({
                  label: name,
                  value: unitDDLId,
                }));
            const optionsDDL = isNew
              ? options
              : options?.map(({ id: optionDDLId, name }) => ({
                  label: name,
                  value: optionDDLId,
                }));

            switch (fieldType) {
              case "number-entry":
                resultElmt = (
                  <div
                    key={id}
                    className="flex flex-row gap-2 w-full items-center "
                  >
                    <div className="flex flex-col gap-2 w-full">
                      <p className="text-es-normal text-es-medium-grey font-es-semibold">
                        {detail}
                      </p>
                      <Input
                        className="flex-1"
                        placeholder="Number"
                        onChange={(val) => {
                          if (
                            numberOrDecimalRegex.test(val) ||
                            val?.length === 0
                          ) {
                            handleChange(val, null, null, id);
                          }
                        }}
                        value={value}
                        disableClear
                      />
                    </div>
                    {!!unitOptions?.length && (
                      <div className="flex flex-col w-full  gap-2">
                        <p className="text-es-normal text-es-medium-grey font-es-semibold">
                          Unit
                        </p>
                        <Dropdown
                          maxMenuHeight={200}
                          className="flex-1"
                          placeholder="Select"
                          options={unitOptions}
                          onChange={({ value: changeValue }) =>
                            handleChange(value, changeValue, null, id)
                          }
                          value={unitOptions?.find(
                            (opt) => opt.value === unitId
                          )}
                          disableClear
                        />
                      </div>
                    )}
                  </div>
                );
                break;
              case "number-entry-with-unit":
                resultElmt = (
                  <div
                    key={id}
                    className="flex flex-row gap-2 w-full items-center "
                  >
                    <div className="flex flex-col gap-2 w-full">
                      <p className="text-es-normal text-es-medium-grey font-es-semibold">
                        {detail}
                      </p>
                      <Input
                        className="flex-1"
                        placeholder="Number"
                        onChange={(val) => {
                          if (
                            numberOrDecimalRegex.test(val) ||
                            val?.length === 0
                          ) {
                            handleChange(val, null, null, id);
                          }
                        }}
                        value={value}
                        disableClear
                      />
                    </div>
                    {!!unitOptions?.length && (
                      <div className="flex flex-col w-full  gap-2">
                        <p className="text-es-normal text-es-medium-grey font-es-semibold">
                          Unit
                        </p>
                        <Dropdown
                          className="flex-1"
                          placeholder="Select"
                          options={unitOptions}
                          onChange={({ value: changeValue }) =>
                            handleChange(null, changeValue, null, id)
                          }
                          value={unitOptions?.find(
                            (opt) => opt.value === unitId
                          )}
                          disableClear
                        />
                      </div>
                    )}
                  </div>
                );
                break;
              case "date-picker":
                resultElmt = (
                  <DatePicker
                    className="w-full"
                    value={value}
                    key={id}
                    onChange={(val) => handleChange(val, null, null, id)}
                    placeholder="Enter Date"
                    label={detail}
                    labelClassName="text-es-normal text-es-medium-grey font-es-semibold pb-0.5"
                    validation={yup.date()}
                  />
                );
                break;
              case "ddl":
                resultElmt = (
                  <div key={id} className="flex flex-col gap-2 w-full">
                    <p className="text-es-normal text-es-medium-grey font-es-semibold">
                      {detail}
                    </p>
                    <Dropdown
                      className="w-full"
                      placeholder="Select"
                      options={optionsDDL}
                      onChange={({ value: changeValue }) => {
                        handleChange(null, null, changeValue, id);
                      }}
                      value={optionsDDL?.find((opt) => opt.value === optionId)}
                      disableClear
                    />
                  </div>
                );
                break;
              case "check-box":
                resultElmt = (
                  <div
                    key={id}
                    className="flex flex-row justify-start items-center w-full"
                  >
                    <Checkbox
                      labelLeft
                      size={6}
                      className="text-es-normal text-es-medium-grey"
                      label={detail}
                      labelClassName="text-es-normal text-es-medium-grey font-es-semibold"
                      checked={value === "Yes"}
                      onChange={(isChecked) =>
                        handleChange(isChecked ? "Yes" : "No", null, null, id)
                      }
                    />
                  </div>
                );
                break;
              case "text-entry":
              default:
                resultElmt = (
                  <div
                    key={id}
                    className="flex flex-row justify-start w-full items-center"
                  >
                    <Input
                      mainWrapperClassName="w-full"
                      label={detail}
                      placeholder="Text"
                      onChange={(val) => handleChange(val, null, null, id)}
                      value={value}
                      validation={yup.string()}
                      disableClear
                      labelClassName="text-es-normal text-es-medium-grey font-es-semibold pb-1"
                    />
                    {!!unitOptions?.length && (
                      <Dropdown
                        className="w-56 ml-4"
                        label="Unit"
                        placeholder="Select"
                        options={unitOptions}
                        onChange={({ value: changeValue }) =>
                          handleChange(null, changeValue, null, id)
                        }
                        value={unitOptions?.find((opt) => opt.value === unitId)}
                        disableClear
                      />
                    )}
                  </div>
                );
            }
            return (
              <div
                className="flex flex-row justify-start items-center"
                key={id}
              >
                {resultElmt}
                <div
                  className={`flex flex-row justify-start items-center mx-4 ${
                    fieldType !== "check-box" ? "mt-6" : "-mb-1"
                  }`}
                >
                  <button
                    type="submit"
                    aria-label="button"
                    className=""
                    onClick={() => handleRemoveElement(detail)}
                  >
                    <img
                      alt="delete"
                      src={trashIcon}
                      style={{ height: 20, width: 20 }}
                    />
                  </button>
                </div>
              </div>
            );
          }
        )}
      </div>
    )}
  </>
);

const NewAttributes = ({ newAttributes, onChangeAttribute, isDuplicate }) => (
  <>
    <div className="flex flex-col justify-center items-start h-full">
      {newAttributes?.map((attribute, idx) => (
        <div
          key={attribute?.id ?? idx}
          className="flex flex-col gap-6 items-start w-full"
        >
          {!attribute?.saved && (
            <div className="flex flex-col gap-2 w-full">
              <p className="text-es-normal text-es-medium-grey font-es-semibold">
                Name
              </p>
              <Input
                placeholder="Name"
                onChange={(val) => onChangeAttribute("detail", val, idx)}
                value={attribute?.detail}
                disabled={attribute?.saved}
                mainWrapperClassName="w-full"
                customErrorMessage={isDuplicate && "Name must be unique"}
              />
            </div>
          )}
          {!attribute?.saved && (
            <div className="flex flex-col gap-2 w-full">
              <p className="text-es-normal text-es-medium-grey font-es-semibold">
                Type
              </p>
              <Dropdown
                options={ATTRIBUTE_TYPES}
                value={attribute?.fieldType}
                onChange={(val) => onChangeAttribute("fieldType", val, idx)}
                isDisabled={attribute?.saved}
                validation={yup.mixed().required()}
                disableClear
                className="w-full"
              />
            </div>
          )}
          {attribute?.fieldType?.value === "ddl" && !attribute?.saved && (
            <div className="flex flex-col gap-2 w-full">
              <p className="text-es-normal text-es-medium-grey font-es-semibold">
                Options
              </p>
              <Dropdown
                isMulti
                isCreatable
                options={attribute?.options}
                onChange={(values) => onChangeAttribute("options", values, idx)}
                value={attribute?.options}
                disableClear
                placeholder="Start Typing..."
                validation={yup.mixed().required()}
              />
            </div>
          )}
          {attribute?.unit && !attribute?.saved && (
            <div className="flex flex-col gap-2 w-full">
              <p className="text-es-normal text-es-medium-grey font-es-semibold">
                Options
              </p>
              <Dropdown
                isMulti
                isCreatable
                options={attribute?.unit?.options}
                onChange={(values) =>
                  onChangeAttribute("unit", values, idx, "options")
                }
                value={attribute?.unit?.options}
                disableClear
                placeholder="Select"
                validation={yup.mixed().required()}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  </>
);

export { SelectedAttributes, NewAttributes };
